export const Api_urls = {
    apiUrl : "https://app.wanteddrivers.in/",
    apiUrl2 : "https://node.wanteddrivers.in/",

}

export const DataTile = [
    {id:1, title:"Looking for Drivers"},
    {id:2, title:"Urgent Hiring for Drivers"},
    {id:3, title:"Looking for Personal Drivers"},
    {id:4, title:"Looking for Commercial Drivers"},
    {id:5, title:"Ambulance Driver required Immediately"},
    {id:6, title:"Looking for Automatic Vehicle Drivers"},
    {id:7, title:"We are looking for School Bus/ Van Drivers"},
    {id:8, title:"Wanted Bus Drivers Immediately"},
    {id:9, title:"Need Experience Lorry / Truck Drivers"},
    {id:10, title:"Wanted Valet Parking Drivers"},
    {id:11, title:"Urgent Need of Delivery Drivers"},
    {id:12, title:"Wanted Part Time Drivers"},
    {id:13, title:"Wanted Full Time Drivers"},
    {id:14, title:"Wanted Drivers Immediately"}
]